import { Sort } from '../constants/common';

export interface ITextValue {
    command: string;
    customerSegments: string[];
}

export interface IAdFromChat {
    chatId: string;
    templateId: string;
    sessionId: string;
    templateJSON: object | null;
    templateExtraFields: object | null;
}

export interface IEditorTemplateData {
    adFromChat: IAdFromChat | null;
    adFromCreateTab: IAdFromCreateTab | null;
    templateFromProject: ITemplateFromProject | null;
}

export interface IAdFromCreateTab {
    campaignAdId: string;
    templateId: string;
    caption: string;
    templateJSON: object | null;
}

export interface ITemplateFromProject {
    id: number;
    name: string;
    templateJSON: object | null;
}

export interface IPaginationParams {
    page?: number;
    size?: number;
    sort?: Sort;
    brandId?: number;
}

export enum ImageModalTabKey {
    ASSETS = 'assets',
    UNSPLASH = 'unsplash',
}
